/**
 *
 *  Modal openener on Click
 *  opens this modal after a click on multiple "add-to-modal" elements.
 *  and can add a special class on modal container.
 *
 */

class Modal {
    constructor(elem) {
        this.elem = elem;
    }

    init() {

        const targetModal = this.elem;
        const allClickIdentifier = document.querySelectorAll('.add-to-modal');
        const modalClose = document.getElementById("modal-close");

        for (
            let clickIdentifier = 0;
            clickIdentifier < allClickIdentifier.length;
            clickIdentifier++
        ) {
            allClickIdentifier[clickIdentifier].addEventListener(
                "click",
                function(e) {
                    e.preventDefault();
                    const dataOnIdentifier = this.getAttribute("data-class");
                    targetModal.classList.add("modal--open");
                    targetModal.classList.add(dataOnIdentifier);

                    // Remove modal and remove special class
                    function removeModal() {
                        targetModal.classList.remove(dataOnIdentifier);
                        targetModal.classList.remove("modal--open");
                    }

                    // Close Icon
                    modalClose.addEventListener("click", function () {
                        removeModal();
                    });

                    // Outside modeal inner
                    // @TODO: remove Modal on Click outside Modal
                    //targetModal.addEventListener ("click", function() { removeModal();} );
                }
            );
        }
    }
}

export default Modal;

/*
http://jira.schalk-office.de:8080/browse/COLWR-1008
https://www.colliers.de/unternehmen/unternehmensstandorte/

<style>
.berlin  #berlin,
.hamburg  #hamburg,
.leipzig  #leipzig,
.duesseldorf  #duesseldorf,
.koeln  #koeln,
.frankfurt  #frankfurt,
.nuernberg  #nuernberg,
.muenchen  #muenchen,
.stuttgart  #stuttgart {
    display: block;
}
</style>
<div class="modal" data-component="03_molecules/Modal">
<div class="modal__inner">
<div class="modal__close" id="modal-close"><span class="line1"></span><span class="line2"></span></div>
<section id="berlin" class="hide">
<h3>Colliers International Berlin GmbH</h3>
<p>Budapester Str. 50<br>
10787 Berlin<br>
Tel. +49 30 202993-0<br>
Fax +49 30 202993-32<br>
<a href="mailto:info.berlin@colliers.com">info.berlin@colliers.com</a></p>
<h3>Colliers International Hotel GmbH</h3>
<p>Budapester Str. 38<br>
10787 Berlin<br>
Tel: +49 30 5858178-10<br>
Fax: +49 30 5858178-99<br>
<a href="mailto:info.hotel@colliers.de">info.hotel@colliers.de</a></p>
</section>
<section id="duesseldorf" class="hide">
<h3>Colliers International Deutschland GmbH</h3>
<p>Niederlassung Düsseldorf<br>
Königsallee 60C<br>
40212 Düsseldorf<br>
Tel. +49 211 862062-0<br>
Fax +49 211 862062-62<br>
<a href="mailto:info.duesseldorf@colliers.com">info.duesseldorf@colliers.com</a></p>
</section>
<section id="frankfurt" class="hide">
<h3>Colliers International Deutschland GmbH</h3>
<p>Niederlassung Frankfurt<br>
Thurn-und-Taxis-Platz 6<br>
60313 Frankfurt am Main<br>
Tel. +49 69 719192-0<br>
Fax +49 69 719192-71<br>
<a href="mailto:info.frankfurt@colliers.com">info.frankfurt@colliers.com</a></p>
<h3>Colliers International Residential GmbH</h3>
<p>Niederlassung Frankfurt<br>
Thurn-und-Taxis-Platz 6<br>
60313 Frankfurt am Main<br>
Tel +49 69 247575-50<br>
Fax +49 69 247575-55<br>
<a href="mailto:info.residential.de@colliers.com">info.residential.de@colliers.com</a></p>
</section>
<section id="hamburg" class="hide">
<h3>Colliers International Hamburg GmbH</h3>
<p>Burchardstr. 17<br>
20095 Hamburg<br>
Tel. +49 40 328701-0<br>
<a href="mailto:info.hamburg@colliers.com">info.hamburg@colliers.com</a></p>
</section>
<section id="muenchen" class="hide">
<h3>Colliers International Deutschland GmbH</h3>
<p>Niederlassung München<br>
Dachauer Str. 63<br>
80335 München<br>
Tel. +49 89 624294-0<br>
Fax +49 89 624294-10<br>
<a href="mailto:info.muenchen@colliers.com">info.muenchen@colliers.com</a></p>
<h3>Colliers International Valuation GmbH</h3>
<p>Dachauer Str. 65<br>
80335 München<br>
Tel: +49 89 442384-100<br>
Fax: +49 89 442384-199<br>
<a href="mailto:info.valuation@colliers.de">info.valuation@colliers.de</a></p>
</section>
<section id="stuttgart" class="hide">
<h3>Colliers International Deutschland GmbH</h3>
<p>Niederlassung Stuttgart<br>
Königstraße 5<br>
70173 Stuttgart<br>
Tel. +49 711 22733-0<br>
Fax +49 711 22733-44<br>
<a href="mailto:info.berlin@colliers.com">info.berlin@colliers.com</a></p>
</section>
<section id="nuernberg" class="hide">
<h3>Colliers International Deutschland GmbH</h3>
<p>Colliers International Nürnberg<br>
Am Tullnaupark 15<br>
90402 Nürnberg<br>
Tel. +49 911 375-9522</p>
</section>
<section id="koeln" class="hide">
<h3>Colliers International Deutschland GmbH</h3>
<p>Niederlassung Köln<br>
Kaiser-Wilhelm-Ring 15<br>
50672 Köln<br>
Tel. +49 221 986537-0<br>
<a href="mailto:info.koeln@colliers.com">info.koeln@colliers.com</a></p>
</section>
<section id="leipzig" class="hide">
<h3>Colliers International Deutschland GmbH</h3>
<p>Colliers International Leipzig<br>
Grimmaischer Steinweg 5<br>
04103 Leipzig<br>
Tel. +49 341 2182990-0<br>
<a href="/cdn-cgi/l/email-protection" class="__cf_email__" data-cfemail="81e8efe7eeafede4e8f1fbe8e6c1e2eeedede8e4f3f2afe2eeec">[email&nbsp;protected]</a></p>
</section>
</div>
</div>
*/
